<template>
  <div>
    <v-container fluid>
      <material-card
        icon="mdi-clipboard-text"
        inline
        title="Create Student General Diary"
      >
        <v-card-actions>
          <router-link :to="{ name: 'viewStudentGeneralDiary' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              top
              right
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card class="px-2" flat>
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium"
                  >Select Academic Year
                  <span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model="academicYearID"
                  required
                  :items="academicYears"
                  key="id"
                  item-value="id"
                  item-text="academicYear"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium"
                  >Select franchisee <span class="error--text">*</span></label
                >
                <div class="control select is-fullwidth">
                  <multiselect
                    class="overflowmultiselect2"
                    label="companyName"
                    track-by="companyName"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="false"
                    :multiple="true"
                    :options="franchiseeArr"
                    v-model="franchiseeID"
                  >
                  </multiselect>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="dates"
                      multiple
                      chips
                      small-chips
                      aria-required="true"
                      label="Select Class Dates"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    multiple
                    :min="minStartDate"
                    :max="maxDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dateMenu.save(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium"
                  >Class-Section <span class="error--text">*</span>
                </label>
                <multiselect
                  class="overflowmultiselect2"
                  label="value"
                  track-by="id"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="classSectionArray"
                  v-model="classSectionID"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium">
                  Title <span class="error--text">*</span></label
                >
                <v-text-field
                  class="my-0 py-1"
                  placeholder="Title"
                  v-model.trim="title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <label class="body-2 font-weight-medium">
                  General Remark <span class="error--text">*</span></label
                >
                <!-- <ckeditor required v-model="GeneralRemark" ref="ckeditorRef"></ckeditor> -->
                <!-- <textarea class="input" rows="3" required clearable v-model="GeneralRemark" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  required
                  v-model="GeneralRemark"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12" md="4">
                <label class="body-2 font-weight-medium"> Select file </label>

                <b-field class="file is-primary">
                  <b-upload
                    @input="onFilechange()"
                    v-model="dropFile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps,
                  .potx,.potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma,
                  .aac, .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm,
                  .mpg, .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
                </div>
                <div v-if="dropFile.length > 0">
                  <v-chip
                    v-for="(file, i) in dropFile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deleteDropFile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    :disabled="hasClicked"
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'

import Utils from '@/utils'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
// import Vue from 'vue'
import moment from 'moment'
// import CKEditor from 'ckeditor4-vue'
// import CustomDatePicker from '../../template/CustomDatePicker.vue'
import MaterialCard from '../../template/MaterialCard.vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'studentGeneralDiary',
  props: ['dateProp'],
  components: {
    Multiselect,
    // CustomDatePicker,
    MaterialCard,
    quillEditor
  },
  data () {
    const today = new Date()
    return {
      total: 0,
      date: moment().format('YYYY-MM-DD'),
      dropFile: [],
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      GeneralRemark: '',
      type: '',
      academicYears: [],
      selectedClassID: '',
      selectedSectionID: '',
      classID: '',
      title: '',
      minStartDate: new Date().toISOString().slice(0, 10),
      maxDate: new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      )
        .toISOString()
        .slice(0, 10),
      dates: [],
      dateMenu: false,
      classWiseSections: [],
      classes: [],
      sections: [],
      tempArray: [],
      hasClicked: false,
      loader: true,
      isWrite: false,
      isLoading: false,
      classSectionArray: [],
      classSectionID: '',
      sendFranchisee: [],
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ]
    }
  },

  async created () {
    if (this.dateProp) {
      this.date = this.dateProp
    }
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    // await this.getClassList()
    await this.getFranchiseeList()
    await this.getYear()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) {
    //   that.instance.execCommand('maximize')
    // }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$dialog.warning({
    //     title: 'Leave Page',
    //     text: 'Do you really want to leave? you have unsaved changes!',
    //     actions: {
    //       false: 'No',
    //       true: {
    //         color: 'success',
    //         text: 'Yes',
    //         handle: () => {
    //           next()
    //         }
    //       }
    //     }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  watch: {
    franchiseeID: async function () {
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassList()
      }
    },
    academicYearID: async function () {
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassList()
      }
    },
    selectedClassID () {
      this.selectedSectionID = ''
    }
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
        this.franchiseeID ||
        this.dates ||
        this.selectedClassID ||
        this.selectedSectionID ||
        this.title ||
        this.GeneralRemark ||
        this.dropFile.length > 0
      return boolAlert
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=false`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const fb = []
        let z = []
        this.classSectionArray = []
        let fbString = ''
        console.log(this.franchiseeID)
        if (
          typeof this.franchiseeID === 'object' &&
          this.franchiseeID !== null
        ) {
          this.franchiseeID.forEach((element) => {
            fb.push(element.id)
          })
        }
        if (fb.length > 0) {
          fbString = fb.toString()
        }

        let { data } = await http.get(
          `${constants.API_URL}/api/student/get-all-classby-franchisee?franchiseeID=${fbString}&academicYearID=${this.academicYearID}`
        )

        if (data) {
          _.map(data, (a) => {
            _.map(a.studentSections, (b) => {
              let franchiseeName = b.studentAdmissions[0].franchisee.companyName
              let franchiseeId = b.studentAdmissions[0].franchisee.id
              b.value = `${franchiseeName}-${a.name} - ${b.name}`
              b.id = { franchiseeID: franchiseeId, sectionID: b.id }
              z.push(b)
            })
          })
        }

        this.classSectionArray = z
        // data.map(a => {
        //   a.studentSections.map(b => {
        //     this.tempArray.push({
        //       id: b.id,
        //       name: `${a.name}-${b.name}`
        //     })
        //   })
        // })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    // changeSections: async function () {
    //   this.selectedStudent = []
    //   this.studentArray = []
    //   try {
    //     this.isLoading = true
    //     let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
    //     if (sectionarray) {
    //       this.classWiseSections = sectionarray.studentSections
    //     } else {
    //       this.classWiseSections = []
    //     }
    //   } catch (e) {
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     console.log('errorMessage', errorMessage)
    //   } finally {
    //     this.isLoading = false
    //   }
    // },

    changeDate: function () {
      return this.dates
      // console.log('selected Dates: ', this.dates)
    },
    save: async function () {
      if (this.classSectionID.length < 1) {
        this.errMsg('Kindly select atleast one class section!')
        return false
      }
      let GeneralRemarkTest = this.GeneralRemark
      GeneralRemarkTest = GeneralRemarkTest.replace(/(<([^>]+)>)/gi, '')
      GeneralRemarkTest = GeneralRemarkTest.replace(/&nbsp;/g, '')
      GeneralRemarkTest = GeneralRemarkTest.trim()
      // console.log(GeneralRemarkTest)
      if (
        GeneralRemarkTest === '' ||
        !GeneralRemarkTest ||
        GeneralRemarkTest === null
      ) {
        return this.$dialog.message.warning('Please fill General Remark', {
          position: 'top',
          timeout: 4000
        })
      }
      if (this.franchiseeID.length === 0) {
        return this.$dialog.message.warning('Please select franchisee', {
          position: 'top',
          timeout: 4000
        })
      }
      let formData = new FormData()

      if (this.franchiseeID.length > 0) {
        this.sendFranchisee = this.franchiseeID.map((obj) => obj.id)
      }

      formData.append('academicYearID', this.academicYearID)
      formData.append('franchiseeID', JSON.stringify(this.sendFranchisee))
      formData.append('title', this.title)
      formData.append('generalRemark', this.GeneralRemark)
      for (let i = 0; i < this.dates.length; i++) {
        formData.append('date', this.dates[i])
      }
      let newArr = _.map(this.classSectionID, (a) => a.id)
      formData.append('sectionID', JSON.stringify(newArr))
      for (let i = 0; i < this.dropFile.length; i++) {
        formData.append('file', this.dropFile[i])
      }
      for (let pair of formData.entries()) {
        console.log(pair)
      }
      this.hasClicked = true
      try {
        this.isLoading = true
        await http.post(
          `${constants.API_URL}/api/v1/communication/studentGeneralDairy`,
          formData
        )
        this.loader = false
        this.isLoading = false
        this.$router.push({ name: 'viewStudentGeneralDiary' })
        return this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    onFilechange () {
      let r = this.dropFile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.dropFile.pop()
        return this.$dialog.warning({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
